import _ from 'lodash';
import c from 'chroma-js';

const fontFamily = (...args) => _.flattenDeep([...args])
  .map(a => `"${a}"`)
  .join(',');

const SERIF_FONTS = '"Helvetica Neue",Helvetica,Arial,"Comic Sans",sans-serif'.split(',');
export const HEADLINE_FONT = 'Montserrat';
export const BODY_FONT = 'Open Sans';
export const HEADLINE_FONT_FAMILY = fontFamily(HEADLINE_FONT, SERIF_FONTS);
export const BODY_FONT_FAMILY = fontFamily(BODY_FONT, SERIF_FONTS);
export const CODE_FONT_FAMILY = 'Monaco,"Courier Neue", Courier,monospace';
export const MAIN_PAGE_MARGIN_WIDTH = '3rem';
export const MAIN_PAGE_MARGIN_HEIGHT = '2rem';
export const MAIN_PAGE_MARGIN_WIDTH_SM = '1rem';
export const MAIN_PAGE_MARGIN_HEIGHT_SM = '1rem';
export const MAIN_PAGE_MARGIN_TOP = '0.5rem';
export const MAIN_PAGE_MARGIN_TOP_SM = '2px';
export const DRAWER_MARGIN_WIDTH = '1.5rem';
export const DRAWER_MARGIN_HEIGHT = '1rem';
export const MAX_CONTENT_WIDTH = '1400px';
export const DEFAULT_BLOCK_PADDING = '1rem';
export const HAIRLINE_COLOR = 'rgb(240,240,240)';
export const BREADCRUMB_FONT_SIZE = '14px'; // match to left menu
export const HEADER_FONT_SIZE = '1.5rem';
export const BODY_FONT_SIZE = '1rem';
export const INPUT_FONT_SIZE = '0.9rem';
export const SUB_FONT_SIZE = '0.666rem';
export const BLUE_DARK = '#052553';

export const BLUE_MED = '#0b5287';

export const BLUE = '#2582C8';

export const BLUE_LIGHT = '#7abce6';

export const BLUE_VERY_LIGHT = '#d3efff';

export const GREEN_DARK = '#385721';

export const GREEN = '#81cf48';

export const GRAY_DARK = '#2A3035';

export const GRAY = '#8A8C8F';

export const GRAY_LIGHT = '#ebeef2';

export const GRAY_JIRA = '#F4F4F4';

export const ACCENT_ORANGE = '#fc502d';

export const RED_ERROR = '#9b0129';

export const BLACK = '#000000';

export const WHITE = '#FFFFFF';

export const TABLE_ROW_SELECTED_TEXT = c(ACCENT_ORANGE).darken().css();

export const SELECTABLE_HIGHLIGHT_COLOR = c(BLUE_VERY_LIGHT).saturate(0.5).css();
export const SELECTED_MENU_HIGHLIGHT_COLOR = WHITE;
export const MEDIA_XS = '576px';
export const MEDIA_SM = '768px';
export const MEDIA_GT_SM = '769px';
export const MEDIA_MD = '992px';
export const MEDIA_LG = '1200px';
export const MEDIA_XL = '1600px';
export const GRID_SIZE_CUTOFF = 700; // note - this is the grid panel size not the window size;

export const px = (n) => {
  if (typeof n === 'string') return n;
  if (typeof n === 'number') return `${n}px`;
  return '';
};
